import { UTCDate } from "@date-fns/utc";
import {
  addDays,
  endOfDay,
  format,
  endOfMonth,
  endOfToday,
  endOfYesterday,
  startOfDay,
  startOfMonth,
  startOfToday,
  startOfYesterday,
  subDays,
  subMonths,
} from "date-fns";
import { defaultDateFormat } from "~/components/Controls/DatePicker";

export type DateRangeInner = [Date | null | undefined, Date | null | undefined];
export type DateRange = {
  startDate?: Date;
  endDate?: Date;
};

export const utcDay = (offsetDays = 0, now: Date = new Date()): string =>
  format(addDays(new UTCDate(now), offsetDays), "yyyy-MM-dd");

export const zeroPad = (value, length) => `${value}`.padStart(length, "0");

export const isDate = (date) => {
  const isDateC = Object.prototype.toString.call(date) === "[object Date]";
  const isValidDateC = date && !Number.isNaN(date.valueOf());
  return isDateC && isValidDateC;
};

export const todayDateRange = (): DateRangeInner => {
  const date = new Date();
  return [startOfDay(date), endOfDay(date)];
};

export const yesterdayDateRange = (): DateRangeInner => {
  return [startOfYesterday(), endOfYesterday()];
};

export const lastDaysDateRange = (days: number): DateRangeInner => {
  return [subDays(startOfToday(), days), endOfToday()];
};

export const todayMonthDateRange = (): DateRangeInner => {
  const currentDate = new Date();
  return [startOfMonth(currentDate), endOfDay(endOfMonth(currentDate))];
};

export const lastMonthDateRange = (): DateRangeInner => {
  const currentDate = subMonths(startOfToday(), 1);
  return [startOfMonth(currentDate), endOfDay(endOfMonth(currentDate))];
};

export const dateFromString = (date?: string): Date | null => {
  if (date) {
    try {
      return new Date(date);
    } catch {
      return null;
    }
  }
  return null;
};

export const stringDateFormat = (str: string | Date, format?: Intl.DateTimeFormatOptions): string =>
  new Date(str).toLocaleDateString(undefined, format || defaultDateFormat);

export const formatDateTime = (iso: string | null | undefined): string =>
    iso ? new Date(iso).toLocaleString() : '—';

export const toUTCWithLocalTime = (date: Date | undefined): Date | undefined => {
  if (!date) {
    return date;
  }
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )
  );
};
